import { render, staticRenderFns } from "./TPSLists.vue?vue&type=template&id=48a1a143&"
import script from "./TPSLists.vue?vue&type=script&lang=js&"
export * from "./TPSLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports